import { ERoutes } from "./dashboardLayout.interface";

export const titles = {
  [ERoutes.Activity]: "Activity",
  [ERoutes.Analytics]: "Analytics",
  [ERoutes.Retail]: "Retail",
  [ERoutes.Wholesale]: "Wholesale",
  [ERoutes.Products]: "Products",
  [ERoutes.Distributors]: "Distributors",
  [ERoutes.Purchase]: "Purchase",
  [ERoutes.Inventory]: "Inventory",
};
